"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_ROLES = void 0;
var AUTH_ROLES;
(function (AUTH_ROLES) {
    AUTH_ROLES[AUTH_ROLES["ANONYMOUS"] = 0] = "ANONYMOUS";
    AUTH_ROLES[AUTH_ROLES["MARGIN_READ"] = 1] = "MARGIN_READ";
    AUTH_ROLES[AUTH_ROLES["USER"] = 2] = "USER";
    AUTH_ROLES[AUTH_ROLES["B2C_USER"] = 3] = "B2C_USER";
    AUTH_ROLES[AUTH_ROLES["ADMIN"] = 4] = "ADMIN";
    AUTH_ROLES[AUTH_ROLES["SERVER_TO_SERVER"] = 5] = "SERVER_TO_SERVER";
    AUTH_ROLES[AUTH_ROLES["MARGINS_ADMIN"] = 6] = "MARGINS_ADMIN";
})(AUTH_ROLES = exports.AUTH_ROLES || (exports.AUTH_ROLES = {}));
//# sourceMappingURL=auth.js.map